// Brand data — sourced from "Web için tüm ürünler.pdf" (official Hupla product pack)
// Individual product photos stored in /public/products/p*.jpg
export const BRANDS = [
  {
    slug: "mamm",
    name: "Mamm",
    logo: "/logos/mamm.webp",
    logoClass: "h-12 max-w-[200px]",
    category: "Kids' Fruit Juice",
    tagline: "captures the essence of nature — pure, balanced, honest",
    image: "/products/mamm-bogo.webp", // Bogo elephant (pink)
    frontImage: "/products/front/mamm.webp",
    heightMm: 220,
    variantImages: [
      { src: "/products/mamm-kika.webp", label: "KIKA Monkey" },
      { src: "/products/mamm-bogo.webp", label: "BOGO Elephant" },
    ],
    palette: { bg: "#FFD53F", accent: "#E4004E", text: "#1A0A00" },
    variants: [
      "Kika — Monkey bottle",
      "Bogo — Elephant bottle",
      "Bambam — Dog bottle",
      "Vak — Duck bottle",
    ],
    highlights: [
      "100% mixed fruit juice (apple, strawberry, plum)",
      "Vitamin C + Vitamin A fortified",
      "No added sugar, no preservatives, no artificial colours",
      "Collectible animal character bottles kids adore",
    ],
    story:
      "Mamm turns hydration into a game. Four cheeky animal characters — Kika the monkey, Bogo the elephant, Bambam the dog and Vak the duck — carry 100% mixed fruit juice with vitamins A and C. A healthy juice with a toy on top.",
    deckPages: [
      "/deck/deck_page-05.webp",
      "/deck/deck_page-06.webp",
      "/deck/deck_page-07.webp",
    ],
  },
  {
    slug: "buzzer",
    name: "Buzzer",
    logo: "/logos/buzzer.webp",
    watermark: "/logos/buzzer-emblem.webp",
    logoClass: "h-24 max-w-[192px]",
    category: "Energy Drink",
    tagline: "peak performance — laser focus and unleashed productivity",
    image: "/products/p17.webp", // 500 mL Guarana can
    frontImage: "/products/front/buzzer.webp",
    heightMm: 134,
    variantImages: [
      { src: "/products/p16.webp", label: "Buzzer 1 L PET", heightMm: 292 },
      { src: "/products/p17.webp", label: "Buzzer 500 mL", heightMm: 168 },
      { src: "/products/p18.webp", label: "Buzzer 250 mL", heightMm: 134 },
      { src: "/products/p19.webp", label: "Buzzer Extra 5G · 150 mL", heightMm: 90 },
    ],
    palette: { bg: "#0B1C4B", accent: "#FF2D3F", text: "#FFFFFF" },
    variants: [
      "Buzzer — 1 L PET Bottle",
      "Buzzer — 500 mL Can",
      "Buzzer — 250 mL Can",
      "Buzzer Extra 5G — 150 mL · Apple & Mulberry",
    ],
    highlights: [
      "Guarana + high-quality caffeine — clean, sustained lift",
      "Increased alertness, focus, memory & endurance",
      "Türkiye's most-loved energy drink for 25 years",
      "Buzzer Extra 5G: 100% apple & mulberry juice + amino acids, L-Theanine, B-complex and Vitamin C",
    ],
    story:
      "Buzzer helps you fire on all cylinders. Guarana releases its caffeine slowly and steadily; B-vitamins keep the mood lifted. No sudden crash — just a longer, cleaner burn. For a functional twist, Buzzer Extra 5G pairs real fruit juice with amino acids, L-Theanine, magnesium and Vitamin C — probably the most nutritionally-thoughtful energy can on the shelf.",
    deckPages: [
      "/deck/deck_page-03.webp",
      "/deck/deck_page-04.webp",
      "/deck/deck_page-02.webp",
    ],
  },
  {
    slug: "multimalt",
    name: "Multimalt",
    logo: "/logos/multimalt.webp",
    logoClass: "h-9 max-w-[198px]",
    category: "Malt Beverage",
    tagline: "health elixir — increases the level of happiness hormones",
    image: "/products/p15.webp", // Multimalt Mango (yellow)
    frontImage: "/products/front/multimalt.webp",
    heightMm: 134,
    variantImages: [
      { src: "/products/p15.webp", label: "Malt · Mango · Apple · Plant Extracts" },
      { src: "/products/p14.webp", label: "Malt & Date · B-vitamins" },
    ],
    palette: { bg: "#F5D34A", accent: "#0E7B8A", text: "#1E1A00" },
    variants: [
      "Mango — Apple, mango, malt · for nursing mothers",
      "Date — Malt & date juice · B-vitamin complex",
    ],
    highlights: [
      "100% barley malt + real fruit juice",
      "Botanicals: fennel, fenugreek, goat's rue, blessed thistle",
      "B1, B2, B3, B5, B6, Biotin, Folic Acid, B12",
      "No preservatives, no colourants, no added sugar",
    ],
    story:
      "Brewed barley malt marries real apple and mango juice, then finished with traditional botanicals long trusted by nursing mothers. Multimalt Date pairs malt with dates and a full B-vitamin complex. Plant-based nourishment, in a can.",
    lifestyle: {
      image: "/lifestyle/multimalt-mom.png",
      caption: "Trusted by nursing mothers for over a century.",
      title: "Nature's nourishment for new mothers.",
      body: "Multimalt draws its strength from two of the most trusted ingredients in maternal wellness — brewed barley malt and rich date fruit — each chosen for how they support the demanding early months of motherhood.",
      benefits: [
        {
          heading: "Barley Malt",
          text: "A time-honoured galactagogue. Barley malt is naturally rich in beta-glucan, which is linked to the release of prolactin — the hormone that helps sustain a healthy milk supply. It also delivers slow-burning complex carbohydrates, iron and B-vitamins that help replenish a nursing mother's energy hour after hour.",
        },
        {
          heading: "Date Fruit",
          text: "A nutrient-dense superfruit for recovery. Dates are packed with natural iron, potassium, magnesium and fibre — nutrients most needed after childbirth. Their gentle natural sugars offer a clean, sustained lift without added sugar, while their fibre supports digestion during the postpartum weeks.",
        },
      ],
    },
    deckPages: ["/deck/deck_page-08.webp"],
  },
  {
    slug: "cafeo",
    name: "Cafeo",
    logo: "/logos/cafeo.webp",
    logoClass: "h-14 max-w-[180px]",
    category: "Iced Coffee",
    tagline: "slows down time — intimate, cozy and warm",
    image: "/products/p11.webp", // Dark Chocolate Truffle can
    frontImage: "/products/front/cafeo.webp",
    heightMm: 134,
    variantImages: [
      { src: "/products/p11.webp", label: "Dark Chocolate Truffle" },
      { src: "/products/p10.webp", label: "Dulce de Leche" },
      { src: "/products/p12.webp", label: "Dark Americano" },
    ],
    palette: { bg: "#2A1B0F", accent: "#F4C169", text: "#F7EBD5" },
    // Cinematic art photograph — three cans among coffee cherries. Rendered by
    // <CafeoMoment /> between the hero and the mood triptych.
    artImage: "/cafeo/art/cafeo-art-1.jpg",
    variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
    highlights: [
      "100% Arabica — brewed, not powdered",
      "Sugar-free · gluten-free · lactose-free",
      "Three moods, three cans",
      "Ready-to-drink, chilled",
    ],
    story:
      "Cafeo is 100% Arabica coffee brewed the way a barista would — then chilled and canned. Three ways to have it: silky Dark Chocolate Truffle, caramel-warm Dulce de Leche, and bracing Dark Americano. No shortcuts.",
    deckPages: ["/deck/deck_page-13.webp"],
  },
  {
    slug: "aperina",
    name: "Aperina",
    logo: "/logos/aperina.webp",
    watermark: "/aperina/aperina-badge.png",
    logoClass: "h-24 max-w-[240px]",
    category: "Aperitif Mix",
    tagline: "unrivaled taste of originality",
    image: "/products/p06.webp",
    frontImage: "/products/front/aperina.webp",
    heightMm: 294,
    variantImages: [{ src: "/products/p06.webp", label: "Original Recipe" }],
    palette: { bg: "#FBF3E7", accent: "#B78535", text: "#5B1A2D" },
    variants: ["1 L PET Bottle — Original Recipe"],
    highlights: [
      "Ready-to-serve fizzy cocktail base",
      "Signature bittersweet bitter-orange soul",
      "Unmistakable colour and flavour",
      "The barman's easy pour",
    ],
    story:
      "Aperina is our ready-to-serve cocktail mix — original flavour notes, unmistakable colour, made for the moment a bartender doesn't want to think. Pour over ice, top with soda, orange slice on the rim. Sundown, sorted.",
    deckPages: ["/deck/deck_page-11.webp"],
    // Bespoke lifestyle art photograph — rendered by <AperinaMoment /> on the
    // Aperina brand page only. Cinematic golden-hour composition.
    artImage: "/aperina/art/aperina-art-1.jpg",
  },
  {
    slug: "white-elephant",
    name: "White Elephant",
    logo: "/logos/white-elephant.webp",
    logoClass: "h-24 max-w-[140px]",
    category: "Premium Mixer",
    tagline: "defines refinement — a touch of elegance and craftsmanship",
    image: "/products/p09.webp", // Barbados Breeze (pink)
    frontImage: "/products/front/white-elephant.webp",
    heightMm: 294,
    variantImages: [
      { src: "/products/p07.webp", label: "Japanese Yuzu Tonic" },
      { src: "/products/p09.webp", label: "Barbados Breeze Tonic" },
      { src: "/products/p08.webp", label: "Bitter Lemon" },
    ],
    palette: { bg: "#F6EFE0", accent: "#B02224", text: "#0F1A12" },
    variants: [
      "Premium Tonic — Japanese Yuzu",
      "Premium Tonic — Barbados Breeze",
      "Bitter Lemon",
    ],
    highlights: [
      "Handcrafted tonic with natural quinine",
      "Up to 85 mg quinine from FeverTree bark",
      "Low-calorie · restaurant & bar grade",
      "1 L PET bottle — bar-ready format",
    ],
    story:
      "For serious bars. Real quinine from FeverTree bark, real lemon juice in the bitter lemon, and two premium tonics — Japanese Yuzu for citrus finesse, Barbados Breeze for a warmer, tropical mix.",
  },
  {
    slug: "desser",
    name: "Desser",
    logo: "/logos/desser.webp",
    logoClass: "h-14 max-w-[180px]",
    category: "Sauces & Syrups",
    tagline: "embodies creativity — breaking all the rules of sweetness",
    image: "/products/p05.webp", // Framboise Madagascar (red)
    frontImage: "/products/front/desser.webp",
    heightMm: 340,
    variantImages: [
      { src: "/products/p02.webp", label: "Salted Caramel" },
      { src: "/products/p03.webp", label: "Dark Chocolate" },
      { src: "/products/p04.webp", label: "White Chocolate" },
      { src: "/products/p05.webp", label: "Framboise Madagascar" },
    ],
    palette: { bg: "#1A0808", accent: "#E8B14B", text: "#F7E2BB" },
    variants: [
      "De Mer Whisper — Salted Caramel",
      "Madagascar Charm — Vanilla · Framboise",
      "Peruvian Noir — Dark Chocolate Truffle",
      "Ivory Pearl — White Chocolate · Macadamia",
      "Belgravia Celestial — White Choc · Pistachio · Banana",
      "Silken Mist — Dulce de Leche · Almond",
    ],
    highlights: [
      "Chef-grade sauces & syrups",
      "Fruity · nutty · deep · exotic profiles",
      "Full-bodied texture, rich mouthfeel",
      "Innovative bottle + pump system",
    ],
    story:
      "Desser is the finishing brushstroke — six flavour profiles crafted for baristas, mixologists and pastry chefs. From De Mer Whisper (salted caramel) to Belgravia Celestial (white chocolate, pistachio, banana).",
    deckPages: ["/deck/deck_page-12.webp"],
  },
];

export const SUSTAINABILITY =
  "For us, sustainability is not a goal — it's a way of living.";

export const MANIFESTOS = {
  first:
    "For us, Hupla represents the story of people gathering around a table — a sip of coffee that sparks conversation, a dessert that brings back childhood memories, an energy drink that fuels creativity. We believe in celebrating the ordinary, transforming every simple act of eating or drinking into a meaningful ritual.",
  second:
    "We don't just produce. We tell stories, connect cultures, and design the flavors of the future. Hupla's journey is not about selling products — it's about creating moments that stay with you.",
  cities:
    "It's a living culture, a shared language that connects people across borders through moments of pleasure. From London to Istanbul, from Berlin to Tokyo — wherever you encounter a Hupla brand, you feel the same spark: the joy of living well.",
};

export const ALMEDA_LOGO = "/logos/dealmeda-mark-red.png";
export const ALMEDA_URL = "https://www.dealmedaseligmann.ch";

export const HUPLA_LOGO = "/hupla-logo.png";
